import { IconButton, IconButtonProps } from '@chakra-ui/react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FaIcon } from '../../fa-icon';

export function PageControlButton({
    icon,
    ...props
}: {
    icon: IconDefinition;
} & Omit<IconButtonProps, 'icon' | 'aria-label'>) {
    return (
        <IconButton
            aria-label="Page control"
            size="sm"
            variant="ghost"
            color="charcoal.900"
            colorScheme="muted"
            _disabled={{ color: 'muted.300' }}
            icon={<FaIcon icon={icon} />}
            {...props}
        />
    );
}
